document.querySelectorAll('.fi-product-media').forEach(media => {
  const img = media.querySelector('img'); 
  const soldOut = media.querySelector('.button.sold-out');

  if (!soldOut || !img) return;
  if (img.complete) {
    soldOut.style.opacity = "1";
  } else {
    img.addEventListener('load', () => {
      soldOut.style.opacity = "1";
    });
  }
});

document.querySelectorAll('.fi-collab-item').forEach(item => {
  const bg = item.style.backgroundImage;
  const match = bg.match(/url\(["']?(.*?)["']?\)/); 
  if (!match) return;

  const imgUrl = match[1];
  const img = new Image();
  img.src = imgUrl;

  if (img.complete) {
    item.classList.add('bg-loaded');
  } else {
    img.onload = () => {
      item.classList.add('bg-loaded');
    };
  }
});

var headings = document.querySelectorAll("h2.f_reveal"); 
headings.forEach(function (heading) { 
  if (heading.textContent.includes("™")) { 
    heading.innerHTML = heading.innerHTML.replace( "™", '<span style="font-size:0.4em;position: relative;top: -15px;">™</span>' ); 
  }
  if (heading.textContent.includes("®")) { 
    heading.innerHTML = heading.innerHTML.replace( "®", '<span class="partner-copy-icon">®</span>' ); 
  } 
});

var headings2 = document.querySelectorAll("h2.cust-pr-head"); 
headings2.forEach(function (heading2) { 
  if (heading2.textContent.includes("®")) { 
    heading2.innerHTML = heading2.innerHTML.replace( "®", '<span style="font-size:0.5em;position: relative;top: -30px;">®</span>' ); 
  } 
});

document.addEventListener("DOMContentLoaded", function() {
  // Check current URL
  if (window.location.href.includes("/products/path-custom-white?view=customize")) {
    // Hide footer
    var footer = document.querySelector("footer");
    if (footer) {
      footer.style.display = "none";
    }
  }
});


jQuery(document).ready(function($) {
  // Disable default click on summary

  // Handle hover on details
  $('details').each(function() {
    var $details = $(this);
    var timer;

    $details.hover(
      function() {
        // Mouse enters: open menu
        clearTimeout(timer); // cancel any pending close
        $details.attr('open', true);
        $('.header-wrap').addClass('menu-open'); // optional wrapper effect
      },
      function() {
        // Mouse leaves: close menu after short delay
        timer = setTimeout(function() {
          $details.removeAttr('open');
          $('.header-wrap').removeClass('menu-open');
        }, 300); // 300ms delay to allow smooth interaction
      }
    );
  });
});

/* SearchBar Open */
document.addEventListener("DOMContentLoaded", function(){

  const form = document.querySelector('#pwSearchPopup form');
  const header = document.querySelector('header');
  const openBtn = document.getElementById("pwOpenSearch");
  const closeBtn = document.getElementById("pwCloseSearch");
  const popup = document.getElementById("pwSearchPopup");

  // PREVENT FORM SUBMIT
  if(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
    });
  }

  // OPEN POPUP
  if(openBtn){
    openBtn.addEventListener("click", function(){
      popup.classList.add("pw-active");
      header.classList.add("header-bg-dark");
    });
  }

  // CLOSE POPUP
  if(closeBtn){
    closeBtn.addEventListener("click", function(){
      popup.classList.remove("pw-active");
      header.classList.remove("header-bg-dark");
    });
  }

});
